export default {
  title: 'Обработка сообщений'
}
